import Grid from "modules/common/components/Grid";
import { getPageUrl } from "utils/getPageUrl";
import { useLanguage, useTranslations } from "contexts/LocalizationContext";
import { PlainContent, SideMenu } from "components";
import {
  ChakraHeading,
  ChakraGridItem as GridItem,
  ChakraDivider as Divider,
  ChakraButton as Button,
  ChakraBox as Box,
} from "@airhelp/react-ui-components";
import { LinkBox } from "../../adapters/index";
import { DynamicComponent } from "../../DynamicComponent";
import Breadcrumbs from "./Breadcrumbs";
import type { PageProps } from "./Page.d";

const Page = ({ components, pageData, iataCode, topic, linkboxPages }: PageProps) => {
  const language = useLanguage();
  const translations = useTranslations();

  const componentsWithProps = components.map((component) => ({
    key: component.fields[0],
    name: component.name,
    props: component.fields.map((f) => pageData[f]?.value),
  }));

  return (
    <Grid mb={{ base: 20, md: 32 }} pt={{ base: 20, md: 32 }}>
      <GridItem gridColumn={{ base: "initial", md: "span 3" }} as="aside">
        <Box position="sticky" top={128} display={{ base: "none", md: "block" }}>
          <SideMenu pageHeading={pageData.heading.value} />
        </Box>
      </GridItem>
      <GridItem gridColumn={{ base: "initial", md: "span 8" }}>
        <ChakraHeading variant="h1" as="h1">
          {pageData.heading.value}
        </ChakraHeading>
        {iataCode && <Breadcrumbs parentValue={topic} childValue={iataCode} />}
        <Box mt={4}>
          <PlainContent content={pageData.intro?.value} />
        </Box>
        <Button as="a" href={getPageUrl(language, "webappNewClaim")}>
          {translations("check_compensation")}
        </Button>
        {componentsWithProps.map((c) => (
          <Box my={5} key={c.key}>
            <DynamicComponent component={c} />
          </Box>
        ))}
        <Divider color="greyscale.100" my={16} />
        <LinkBox linkboxPages={linkboxPages} />
      </GridItem>
    </Grid>
  );
};

export default Page;
